import { SocialSharing } from './SocialSharing'
import { withSocialSharing } from './withSocialSharing'

const ConnectedSocialSharing = withSocialSharing(SocialSharing)
export { ConnectedSocialSharing as SocialSharing }
